import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconCommentsSvg } from "./IconCommentsSvg.mjs";
const IconComments = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconCommentsSvg, ...iconProps });
};
export {
  IconComments
};
